<template>
	<div>
		<div class="card mb-4 shadow-sm">
			<div class="card-body">
				<h4 class="align-items-center card-title d-flex mb-4">
					<span class="mr-auto">{{ field.label }} ({{ files.length }})
					<span v-if="field.field === 'event.batches'"> [unique: {{unique_batches}}] </span>
					</span>
					<button
						class="btn btn-sm btn-outline-primary"
						v-if="files.length"
						v-b-toggle="'files' + field.field"
					>
						<b-icon icon="eye" />
					</button>
					<button
						class="btn btn-sm btn-outline-primary ml-2"
						v-if="files.length"
						@click="download"
					>
						<b-icon icon="download" />
					</button>
				</h4>
				<b-collapse :id="'files' + field.field">
					<table
						class="table table-sm"
						v-if="files.length && field.field !== 'event.batches'"
					>
						<thead>
							<tr>
								<th v-if="field.field !== 'event.data'">Tag</th>
								<th width="100%">File</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr
								:key="i"
								v-for="(f, i) in files"
							>
								<td v-if="field.field !== 'event.data'">{{ f[2]
								}}</td>
								<td v-b-tooltip.hover.top="f[0]">{{ f[1] }}</td>
								<td v-if="field.field !== 'event.data'">{{ f[3]
								}}</td>
								<td class="pr-0">
									<button
										class="btn btn-sm btn-outline-danger"
										@click="remove(f)"
										v-if="edit"
									>
										<b-icon icon="x" />
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<table
						class="table table-sm"
						v-if="files.length && field.field === 'event.batches'"
					>
						<thead>
							<tr>
								<th>id</th>
								<th>include</th>
								<th>batch_id</th>
								<th>batch_from_date</th>
								<th>batch_till_date</th>
								<th>file_name</th>
								<th>upload_time</th>
								<th>upload_by</th>
								<th>data_types</th>
							</tr>
						</thead>
						<tbody>
							<tr
								:key="i"
								v-for="(f, i) in files"
							>
								<td>
									<router-link :to="'/batch/' + measurement._id + '/' + f._id">
									{{ f._id }}
									</router-link>
								</td>
								<td v-if="edit">{{f.include}}</td>
								<td v-else>{{f.include}}</td>
								<td>{{f.batch_id}}</td>
								<td>{{f.batch_from_date}}</td>
								<td>{{f.batch_till_date}}</td>
								<td>{{f.file_name}}</td>
								<td>{{(new Date(f.upload_time*1000)).toLocaleString("en-ZA")}}</td>
								<td>{{f.uploaded_by_name}}</td>
								<td>{{f.data_types}}</td>
							</tr>
						</tbody>
					</table>
				</b-collapse>
			</div>
			<div
				class="card-footer"
				v-if="!field.readonly && edit"
			>
				<div class="form-row">
					<div
						class="col"
						v-if="Array.isArray(field.tags)"
					>
						<select
							class="form-control form-control-sm"
							v-model="tag"
						>
							<option :value="null">Select description...</option>
							<option
								:key="t"
								:value="t"
								v-for="t in field.tags"
							>{{ t }}</option>
						</select>
					</div>
					<div
						class="col"
						v-if="field.field === 'event.otherfiles'"
					>
						<input
							class="form-control form-control-sm"
							placeholder="Description..."
							type="text"
							v-model="tag"
						>
					</div>
					<div
						class="col"
						v-if="!field.readonly"
					>
						<b-form-file
							drop-placeholder="Drop file here..."
							placeholder="Select a file..."
							size="sm"
							:state="Boolean(file)"
							v-model="file"
							:accept="field.accept"
						></b-form-file>
					</div>
					<div
						class="col"
					>
						<select
							class="form-control form-control-sm"
							v-model="creator_id"
						>
							<option :value="null">Select creator ..</option>
							<option
								:key="t._id"
								:value="t._id"
								v-for="t in options"
							>{{ t.name }}</option>
						</select>
					</div>
					<div class="col-auto">
						<button
							class="btn btn-sm btn-outline-primary"
							:disabled="!Boolean(file) || (Array.isArray(field.tags) && !tag)"
							@click="upload"
						>
							<b-icon icon="upload" />
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { readFieldFlat } from '@/util'
import apiClient from '@/apiClient'
import _ from 'lodash'

export default {
	props: ['edit', 'field', 'measurement'],
	data() {
		return {
			file: null,
			tag: null,
			creator_id: null,
			options: []
		}
	},
	computed: {
		apiName() {
			// TODO move to field defs?
			return this.field.field
				.replace('event.', '')
				.replace('data', 'measurementdata')
				.replace('sheets', '')
		},
		gfsName() {
			// TODO move to field defs?
			return this.field.field
				.replace('event.', '')
				.replace('archsheets', 'arch')
				.replace('codingsheets', 'codings')
				.replace('data', 'concat')
		},
		files() {
			const arr = []
			const f = readFieldFlat(this.measurement, this.field.field)
			if (this.field.field === 'event.data') {
				if (f) arr.push(f)
			} else if (f) {
				arr.push(...f)
			}
			if (this.field.field === 'event.batches') {
				return _.orderBy(arr, (e) => parseFloat(e.batch_id))
			}
			return arr
		},
		unique_batches() {
			if (this.field.field === 'event.batches') {
				var batchids = new Set(this.files.map((f) => f.batch_id))
				return batchids.size
			} else {
				return ''
			}
		}
	},
	methods: {
		readFieldFlat,
		download() {
			this.$emit('download', this.apiName)
		},
		async upload() {
			this.$emit('upload', this.apiName, this.file, this.tag, this.creator_id)
			this.file = null
		},
		async remove(f) {
			const [id, filename] = f
			if (confirm(`Remove ${filename} (${id})?`)) {
				this.$emit('delete', this.gfsName, id)
			}
		},
		async refreshOptions() {
			const f = this.field
			if (!f) return
			this.options.splice(0, this.options.length)
			let values = await apiClient._cachedCall('/useridtranslator')
			if (!Array.isArray(values)) {
				values = Object.entries(
					values
				).map(([_id, label]) => {
					var retval = {}
					retval._id = _id
					retval.name = label
					return retval
				})
			}
			// TODO: sorting
			this.options.push(...values)
		}
	},
	mounted() {
		this.refreshOptions()
	}
}
</script>
